const spacing = (factor, baseFontSize = 16) =>
  `${(2 * factor) / baseFontSize}rem`

export default spacing
